import React, { useEffect } from 'react';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { Spinner } from '@leagueplatform/genesis-core';
import { LOCAL_STORAGE_TENANT_ID_KEY } from 'constants/locale-storage';
import { useLocalStorage } from 'usehooks-ts';

export const CSAuthSignOut = () => {
  const [, setTenantId] = useLocalStorage(LOCAL_STORAGE_TENANT_ID_KEY, '');
  useEffect(() => {
    StandaloneAuth.client.logout({
      returnTo: window.location.origin,
    });
    setTenantId('');
  }, [setTenantId]);

  return <Spinner loading />;
};
